<div class="content">
  <div class="content__inner">
    <div class="content__main">
      <app-messages-panel></app-messages-panel>
      <ng-container #content></ng-container>
    </div>
    <div class="content__sidebar">
      <app-marketing></app-marketing>
      <app-activity-panel></app-activity-panel>
    </div>
  </div>
</div>
